import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {WidgetInnerAlertComponent} from '../../widget-inner-alert';
import {AspreaderAlgoParamsError} from './aspreader-algo-params-errors';

@Component({
    selector: 'widget-order-aspreader-algo-params-alert',
    templateUrl: 'widget-order-aspreader-algo-params-alert.component.html',
    styleUrls: ['../../widget-inner-alert/widget-inner-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetOrderAspreaderAlgoParamsAlertComponent
    extends WidgetInnerAlertComponent
    implements OnInit {

    public override readonly title: string = 'components.widgets.trade-widget.autospreader_error_title';

    @Input()
    public aspreaderAlgoParamsErrors: AspreaderAlgoParamsError[];

    public readonly AspreaderAlgoParamsError = AspreaderAlgoParamsError;

}
